import { render, staticRenderFns } from "./checkbox-form.vue?vue&type=template&id=046940e8&scoped=true"
import script from "./checkbox-form.vue?vue&type=script&lang=ts"
export * from "./checkbox-form.vue?vue&type=script&lang=ts"
import style0 from "./checkbox-form.vue?vue&type=style&index=0&id=046940e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046940e8",
  null
  
)

export default component.exports